import { QuestControlProps } from './index'
import CheckboxControl from '../CheckboxControl'

interface Props extends QuestControlProps<Array<string>> {
  options: Array<{ label: string; value: string }>
  disabled?: boolean
}

const QuestCheckboxGroupControl = ({
  options,
  disabled,
  value = [],
  onChange
}: Props) => {
  return (
    <div className={'quest-group-control'}>
      {options.map((option: { label: string; value: string }) => (
        <CheckboxControl
          key={option.value}
          name={option.value}
          disabled={disabled}
          value={value}
          onChange={onChange as (value: boolean | string[] | string) => void}
        >
          {option.label}
        </CheckboxControl>
      ))}
    </div>
  )
}

export { QuestCheckboxGroupControl }
